import jwtAuthAxios from "../../../services/jwtAuth";
import { createSlice, createAsyncThunk, createEntityAdapter } from '@reduxjs/toolkit';

export const getAll = createAsyncThunk("periodePendaftaran/getAll", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/periode_pendaftaran`);
    return response.data;
});

export const getAllActive = createAsyncThunk("periodePendaftaran/getAllActive", async() => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/periode_pendaftaran/active`);
    return response.data;
});

export const getById = createAsyncThunk("periodePendaftaran/getById", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.get(`v1/master/periode_pendaftaran/${val}`);
    return response.data;
});

export const update = createAsyncThunk("periodePendaftaran/update", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.put(`v1/master/periode_pendaftaran`,val);
    return response.data;
});

export const save = createAsyncThunk("periodePendaftaran/save", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.post(`v1/master/periode_pendaftaran`,val);
    return response.data;
});

export const remove = createAsyncThunk("periodePendaftaran/remove", async(val) => {
    let token = await localStorage.getItem('auth_token');
    jwtAuthAxios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const response = await jwtAuthAxios.delete(`v1/master/periode_pendaftaran/${val}`);
    return response.data;
});


const initialState = {
    loading : false,
    data : {},
    dataList : [],
    dataListActive : []
}

const periodePendaftaranSlice=createSlice ( {
                                                name : "periodePendaftaranSlice" , initialState : initialState , extraReducers : {
        [ getAll.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ getAll.fulfilled ] : ( state , action ) => {
            state.dataList=action.payload;
            state.loading=false;
        } ,
        [ getAll.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,
        
        [ getAllActive.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ getAllActive.fulfilled ] : ( state , action ) => {
            state.dataListActive=action.payload;
            state.loading=false;
        } ,
        [ getAllActive.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ getById.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ getById.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ getById.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ update.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ update.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ update.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ save.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ save.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ save.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,

        [ remove.pending ] : ( state , action ) => {
            state.loading=true;
        } ,
        [ remove.fulfilled ] : ( state , action ) => {
            state.data=action.payload;
            state.loading=false;
        } ,
        [ remove.rejected ] : ( state , action ) => {
            state.loading=false;
        } ,


    }
} )

export const periodePendaftaranSelector = (state) => state.periodePendaftaran;
export default periodePendaftaranSlice.reducer;
